'use client'

import { useEffect, useRef } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router'
import accessClient from './accessClient'
import { useSession } from './SessionContext'

/**
 * Invisible redeem: POST ?access= code, then always strip the param (success or failure).
 * No SoftGate UI.
 */
export default function AccessRedeem() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { hydrate, onAccessGranted } = useSession()
  const inFlightRef = useRef<string | null>(null)

  useEffect(() => {
    const code = searchParams.get('access')
    if (!code) {
      return
    }

    if (inFlightRef.current === code) {
      return
    }
    inFlightRef.current = code

    const stripAccessParam = () => {
      const next = new URLSearchParams(searchParams)
      next.delete('access')
      const search = next.toString()
      navigate(
        { pathname: location.pathname, search: search ? `?${search}` : '' },
        { replace: true }
      )
    }

    ;(async () => {
      try {
        const result = await accessClient.validateAccess(code)
        if (result.ok) {
          onAccessGranted?.(true)
          await hydrate()
        }
      } catch {
        /* strip even on network/parse failure */
      } finally {
        stripAccessParam()
        inFlightRef.current = null
      }
    })()
  }, [searchParams, navigate, location.pathname, hydrate, onAccessGranted])

  return null
}
